import './App.css';
import { Route, Routes } from "react-router-dom";
import Dashboard from './components/Dashboard'
import Navbar from './components/Navbar'
import CustomerTable from './components/Table/Customer/protable with pagination/CustomerTable';
import OrderTable from './components/Table/Order/protable_receipt/OrderTable';

function App() {
  return (
    <>
      <Navbar/>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/customers" element={<CustomerTable/>} />
        <Route path="/orders" element={<OrderTable />} />
      </Routes>
    </>
  );
}

export default App;
